import styled from "styled-components"

import Modal, {ModalInner} from "@irati/ui/src/Modal"
import padding from "@irati/ui/src/global/padding"
import {H3} from "@irati/ui/src//Typography/Heading"
import Card from "@irati/ui/src/Layout/Card"
import {Para} from "@irati/ui/src/Labels"
import {greys} from "@irati/ui/src/global/colors"
import Button from "@irati/ui/src/Button"

export const EmptyRows = styled(Card)`
  border: 2px dashed ${greys.mediumLight};
  box-shadow: none;
  padding: 90px;
`

export const EmptyH3 = styled(H3)`
  margin: 0 auto ${padding.tiny};
`

export const EmptyPara = styled(Para)`
  margin-bottom: ${padding.base};
`

export const StyledModal = styled(Modal)`
  ${ModalInner} {
    padding: ${padding.tiny};
  }
`

export const RowButtonWrapper = styled.div`
  text-align: center;
`

export const DeleteRowButton = styled(Button)`
  margin-right: ${padding.tiny};
`
